module.exports = __webpack_public_path__ + "img/indent-increase-1.27bf0145.svg";